module.exports = __webpack_public_path__ + "img/blackStar.83c6200b.webp";